import { copyText } from "@/lib/partners";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";

const Block = ({ title, kicker, body, testid }) => (
  <div className="bg-white border border-gray-200 p-6">
    <div className="flex items-start justify-between gap-4 mb-4">
      <div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#c19a6b] font-bold">{kicker}</p>
        <h3 className="font-display text-xl mt-1">{title}</h3>
      </div>
      <Button data-testid={`copy-${testid}`} onClick={() => copyText(body, `${title} copied`)} variant="outline" size="sm" className="h-9 rounded-sm text-[11px] uppercase tracking-wider shrink-0">
        <Copy size={12} className="mr-1.5" /> Copy
      </Button>
    </div>
    <p className="text-sm text-gray-700 whitespace-pre-line leading-relaxed" data-testid={testid}>{body}</p>
  </div>
);

export const RealtorOutreach = ({ realtor }) => {
  const o = realtor.outreach || {};
  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="realtor-outreach">
      <div className="space-y-6">
        <Block kicker="Step 1" title="Initial email" testid="outreach-email" body={`Subject: ${o.email_subject}\n\n${o.email_body}`} />
        <Block kicker="Step 2" title="Instagram / LinkedIn DM" testid="outreach-dm" body={o.dm} />
      </div>
      <div className="space-y-6">
        <Block kicker="Step 3" title="Phone talking point" testid="outreach-phone" body={o.phone_script} />
        <div className="bg-black text-white p-6">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#c19a6b] font-bold mb-4">Fast links</p>
          <div className="space-y-3">
            {[
              ["Presentation link", realtor.links.presentation_url, "copy-outreach-presentation"],
              ["Client link", realtor.links.client_url, "copy-outreach-client"],
            ].map(([label, value, testid]) => (
              <button
                key={label}
                data-testid={testid}
                onClick={() => copyText(value, `${label} copied`)}
                className="w-full text-left border border-white/15 hover:border-[#c19a6b] px-4 py-3 transition-colors duration-200"
              >
                <p className="text-[10px] uppercase tracking-[0.18em] text-white/50">{label}</p>
                <p className="text-sm text-white/85 truncate">{value}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
